import React, { memo, useEffect, useState } from 'react'
import { orNull } from 'root/src/shared/util/ramdaPlus'
import classNames from 'classnames'
import Button from 'root/src/client/web/base/Button'
import withStyles from '@material-ui/core/styles/withStyles'
import { colorsNew, ltGtMediaQuery } from 'root/src/client/web/commonStyles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LoadingSpinner from 'root/src/client/web/base/LoadingSpinner'
import Image from 'next/image'

const styles = {
	wrapper: {
		position: 'relative',
		width: '100%',
		height: 42,
		textAlign: 'center',
	},
	wrapperSubmit: {
		[ltGtMediaQuery]: {
			width: 109,
			alignSelf: 'flex-start',
		},
	},
	contentWrapper: {
		alignItems: 'center',
	},
	iconContainer: {
		margin: [[0, 0, 0, 10]],
	},
	icon: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: 24,
		height: 24,
		margin: [[0, 10]],
	},
}

const LoadingButton = ({
	children, onClick, classes, formType, buttonType, isSubmit, className, isLoading, icon, iconSize,
	disabled, submitsBlock, iconPosition = 'left',
}) => {
	const [loading, setLoading] = useState(false)

	useEffect(() => () => setLoading(false), [])

	return (
		<div className="flex layout-row layout-align-start">
			<div className={classNames(classes.wrapper, className,
				{
					[classes.wrapperSubmit]: isSubmit,
				})}
			>
				<Button
					disabled={loading || disabled || isLoading || submitsBlock}
					onClick={e => onClick(e, setLoading)}
					formType={formType}
					buttonType={buttonType}
				>
					<div className={classNames('flex layout-row layout-align-center-stretch', classes.contentWrapper)}>
						{iconPosition === 'right' ? children : ''}
						{orNull(icon,
							<div className={classes.iconContainer}>
								{icon && typeof icon.src === 'string'
									? (
										<div className={classes.icon}>
											<Image
												src={icon.src}
												unoptimized
												height={icon.height}
												width={icon.width}
											/>
										</div>
									)
									: <FontAwesomeIcon icon={icon} size={iconSize || 'lg'} color={colorsNew.dark2} />
								}
							</div>)}
						{iconPosition === 'left' ? children : ''}
					</div>
					<LoadingSpinner loading={loading || isLoading} />
				</Button>
			</div>
		</div>
	)
}
export default withStyles(styles, { name: 'MuiLoadingButton' })(memo(LoadingButton))
